var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_3",
    d: "m353.188,252.052c-23.51,0 -46.594,-3.677 -68.469,-10.906c-10.719,-3.656 -23.896,-0.302 -30.438,6.417l-43.177,32.594c-50.073,-26.729 -80.917,-57.563 -107.281,-107.26l31.635,-42.052c8.219,-8.208 11.167,-20.198 7.635,-31.448c-7.26,-21.99 -10.948,-45.063 -10.948,-68.583c0.001,-16.991 -13.822,-30.814 -30.812,-30.814l-70.52,0c-16.99,0 -30.813,13.823 -30.813,30.813c0,194.75 158.438,353.187 353.188,353.187c16.99,0 30.813,-13.823 30.813,-30.813l0,-70.323c-0.001,-16.989 -13.824,-30.812 -30.813,-30.812z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall1);
export default __webpack_public_path__ + "static/media/call1.eef06d01bc20f7ce9960799564f3aa33.svg";
export { ForwardRef as ReactComponent };